import React from 'react';
import BidComponent from './BidComponent';

import { array, bool, func } from 'prop-types';
import { I18n as I } from 'react-redux-i18n';
import OnlineAuctionsDrawerItem from '../auctions/OnlineAuctionsDrawerItem';

import { Modal } from 'antd';

import { LoaderOverlay } from 'vdlib';

const AuctionBidModal = ({
  auction,
  best,
  bidStep,
  handleBidSubmit,
  creatingAuctionBidsFor,
  loading,
  onHide,
  onSubmit,
  show,
  userId,
  merchantFees,
  membershipID,
}) => {
  return (
    <Modal onCancel={onHide} title={I.t('OFFER')} visible={show} footer={null}>
      <LoaderOverlay loading={loading} />
      {auction && auction.OnlineMode ? (
        <OnlineAuctionsDrawerItem
          auction={auction}
          key={auction.ID}
          loading={creatingAuctionBidsFor === auction.ID}
          onBid={onSubmit}
          open={true}
          partyId={userId}
          merchantFees={merchantFees}
          membershipID={membershipID}
        />
      ) : (
        <BidComponent
          auction={auction}
          onSubmit={onSubmit}
          userId={userId}
          merchantFees={merchantFees}
          membershipID={membershipID}
        />
      )}
    </Modal>
  );
};

AuctionBidModal.propTypes = {
  bids: array,
  isBronze: bool,
  loading: bool,
  onCancel: func,
  onHide: func,
  onSubmit: func.isRequired,
  show: bool,
};

export default AuctionBidModal;
